<template>
  <div class="confirm-modal">
    <div class="confirm-modal__title" v-if="title">
      <b>{{ title }}</b>
    </div>
    <div class="confirm-modal__text">
      {{ message }}
    </div>
    <div class="confirm-modal__actions">
      <AppBtn theme="success" class="mr-3 light" @click="$modals.close(true)">
        {{ confirmText }}
      </AppBtn>
      <AppBtn theme="warning" class="light" @click="$modals.close(false)">
        {{ cancelText }}
      </AppBtn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    message: {
      type: String,
      default: "Вы уверены, что хотите совершить это действие?"
    },
    confirmText: {
      type: String,
      default: "Подтвердить"
    },
    cancelText: {
      type: String,
      default: "Отмена"
    }
  }
};
</script>

<style lang="scss">
.modal.confirmation-modal {
  max-width: 600px;
}
.confirm-modal {
  &__title {
    font-size: 21px;
    text-align: center;
    margin-bottom: 20px;
    text-transform: uppercase;
  }

  &__actions {
    display: flex;
    justify-content: center;
    .btn {
      width: 140px;
    }
  }

  &__text {
    font-size: 17px;
    color: c(grey_lvl_5);
    text-align: center;
    max-width: 420px;
    margin: 0 auto 30px;
  }

  &:first-child {
    margin-right: 40px;
  }
}
</style>
